import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { createStore, applyMiddleware } from 'redux';
import { Provider } from 'react-redux';
import reducers from './reducers';
import reduxThunk from 'redux-thunk';
import { loadState, saveState } from './storage'; 

const persistedState = loadState();

const store = createStore(
  reducers, //todos los reducers
  persistedState, //estado inicial
  applyMiddleware(reduxThunk)
);

store.subscribe(() => {
  saveState(store.getState());
});

ReactDOM.render(
  //<React.StrictMode>
    <Provider store={store}>
      <App />
    </Provider>,
  //</React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
